import React, { useEffect, useState } from "react";
import ProductsService from "../../../api/services/products.service";
import { useLocation, useParams } from "react-router-dom";
import Loading from "../../../components/common/loading/Loading";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import ImageSelect from "../../../components/common/image-select/ImageSelect";
import Button from "../../../components/common/button/Button";
import styles from "./EditProducts.module.scss";
import { ProductsTypes } from "../../../api/types/products.types";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

const EditVariantImages = () => {
  const { t } = useTranslation("translation");
  const [productDetail, setProductDetail] = useState<Partial<ProductsTypes>>(
    {},
  );
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { variant_id } = location.state || {};
  const [deletedImageIds, setDeletedImageIds] = useState<string>("");
  const [imageOrders, setImageOrders] = useState<
    { id: number; order: number }[]
  >([]);

  useEffect(() => {
    setLoading(true);
    const getDetails = async () => {
      try {
        const res = await ProductsService.getVariantById(
          variant_id,
          Number(id),
        );
        setProductDetail(res.data);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    getDetails();
  }, [id, variant_id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAddLoading(true);
    try {
      const formData = new FormData();

      if (deletedImageIds) {
        formData.append("delete_images", deletedImageIds);
      }

      if (imageOrders.length > 0) {
        formData.append("order_images", JSON.stringify(imageOrders));
      }

      await ProductsService.updateProductVariantImage(
        variant_id,
        Number(id),
        formData,
      );
      toast.success(t("products_details.images_updated"));
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("error_message");
      toast.error(message);
    } finally {
      setAddLoading(false);
    }
  };

  const handleDeletedImagesChange = (deletedIds: string) => {
    setDeletedImageIds(deletedIds);
  };

  const handleImageOrderChange = (orders: { id: number; order: number }[]) => {
    setImageOrders(orders);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <TitleUpdater title={t("edit_images")} />
      <div className={styles.grid}>
        <div className={styles.left}>
          <div className={styles.form_category}>
            <p className={styles.title}>Media</p>
            <div className={styles.form_content_column}>
              <ImageSelect
                onImagesChange={(images) => {}}
                onDeletedImagesChange={handleDeletedImagesChange}
                onImageOrderChange={handleImageOrderChange}
                existingImages={productDetail.images}
                disableUpload
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.button}>
        <Button type="submit" disabled={addLoading}>
          {addLoading ? t("buttons.loading") : t("submit")}
        </Button>
      </div>
    </form>
  );
};

export default EditVariantImages;
